(function ($) {

	function isFirstStep() {
		return $('.quote-process__form form .second-page').css('display') === 'none';
	}

	function createCustomSelects(selector) {
		const $selects = $(`${selector} form .gform_fields>li select`);
		$selects.each(function () {

			const $options = $(this).children('option')
			const self = $(this);

			$(this).hide();
			$(this).wrap('<div class="select"></div>');
			$(this).after('<div class="select-styled"></div>');

			const $styledSelect = $(this).next('div.select-styled');

			if ($(this).val()) {
				$styledSelect.text($(this).val());
				$(this).parents('.gfield_contains_required').addClass('hide-asterisk');
			} else {
				$styledSelect.text($options.eq(0).text());
			}

			const $list = $('<ul />', {
				'class': 'select-options'
			}).insertAfter($styledSelect);

			$options.each(function () {
				let tooltipMarkup = '';
				if ($(this).data('tooltipText')) {
					tooltipMarkup = `<div class="question-tooltip"></div><div class="tooltip-text">${$(this).data('tooltipText')}</div>`
				}
				$list.append(`<li rel="${$(this).val()}"> ${$(this).data() ? tooltipMarkup : ''} ${$(this).text()}</li>`)
			})

			$styledSelect.on('click', function (e) {
				const $defaultSelectOptions = $(this).next('ul.select-options')
				e.stopPropagation();
				$('div.select-styled.active').not(this).each(function () {
					$(this).removeClass('active')
					$defaultSelectOptions.hide();
					if (!$defaultSelectOptions.length) {
						$(this).next('.enhanced-select-wrapper').hide();
					}
				});
				$(this).toggleClass('active')
				$defaultSelectOptions.toggle();
				if (!$defaultSelectOptions.length) {
					$(this).next('.enhanced-select-wrapper').toggle();
					$(this).next('.enhanced-select-wrapper').find('.material__form_field').focus()
				}
			});

			const $listItems = $list.children('li');

			$listItems.on('click', function (event) {

				if ($(this).find('.question-tooltip')[0] === event.target) {
					event.stopImmediatePropagation();
				} else {

					if ($(this).find('.overlay')[0] === event.target) {
						$list.find(".overlay").hide();
					} else {
						const immediateText = $(this).contents().not($(this).children()).text();
						$styledSelect.text(immediateText).removeClass('active');
						$styledSelect.addClass('selected')
						self.val($(this).attr('rel'));
						$list.hide();
						self.parents('.gfield_contains_required').addClass('hide-asterisk');
						self.trigger('change');
					}
				}

			});

			$(document).on('click', function (event) {
				$styledSelect.removeClass('active');


				if (!$(event.target).hasClass('material__form_field')) {
					$styledSelect.next('.enhanced-select-wrapper').hide()
					$styledSelect.next('.enhanced-select-wrapper').find('.material__form_field').val('')
					$styledSelect.next('.enhanced-select-wrapper').find('.select-options .no-results').remove()
					$styledSelect.next('.enhanced-select-wrapper').find('.select-options li').each(function() {
						$(this).show()
						this.style.display === 'list-item' && $(this).removeAttr('style')
					})
				}

				if (!$(event.target).hasClass("overlay")) {
					$list.find(".overlay").hide();
					$list.hide();
				}
			});
		});
	}

	$(document).on('click', function (event) {
		if ($(event.target).hasClass("overlay")) {
			$(event.target).hide();
		}
	});


	function toggleFormSteps() {
		const $formSteps = $('.gf_page_steps');
		const $formStepsClone = $formSteps.clone();
		$formSteps.remove();
		$('.gform_page_footer').prepend($formStepsClone);

		if (isFirstStep()) {
			$('.quote-process__form form .gf_step_last').hide();
		} else {
			$('.quote-process__form form .gf_step_first').hide();
		}
	}

	function replaceLabels() {
		const $labels = $('.move-label-to-input>label');
		const $labelsSiblings = $labels.siblings();
		$labelsSiblings.each(function () {
			$(this).append($(this).siblings());
		});
	}

	function createMaterialInputs(selector) {
		const $inputs = $(`${selector} form .gform_fields>li input,textarea`);
		$inputs.addClass('material__form_field');
		$inputs.siblings('label').addClass('material__form_label');
		$inputs.parent().addClass('material__form_group');
	}

	function toggleValidationAsterisk(selector) {
		$(`${selector} form .gfield_contains_required input`).each(function () {

			if ($(this).val().length) {
				$(this).parents('.gfield_contains_required').addClass('hide-asterisk');
			}

			$(this).on('focus', function () {
				$(this).parents('.gfield_contains_required').addClass('hide-asterisk');
			});

			$(this).on('blur', function () {
				if (!$(this).val().length) {
					$(this).parents('.gfield_contains_required').removeClass('hide-asterisk');
				}
			});

			$(this).on('blur', function () {
				if($(this).parents('.ginput_container').hasClass('ginput_container_phone') && $(this).val()==='(___) ___-____') {
					$(this).parents('.gfield-phone').removeClass('hide-asterisk');
				}
			});

			$('.chosen-search > input').on('blur', function () {
				if ($('.quote-process__form form .chosen-single > span').text() !==
					$('.quote-process__form form .chosen-results > li').eq(0).text()) {
					$(this).parents('.gfield_contains_required').addClass('hide-asterisk');
				}
			});
		});
	}

	function addTooltipForFields() {
		$('.field-with-tooltip').prepend('<div class="question-tooltip"></div>');
	}

	function createFormProgressBar() {
		$('.quote-process__form').append(`<div class="progress-bar">
											<div class="first-step"></div>
											<div class="second-step"></div>
										</div>`);
		if (!isFirstStep()) {
			$('.second-step').show();
		}
	}

	function changeStyleOnFirstCharacter(selector, style) {
		const text = $(selector).text();
		const newFirstCharacter = `<span style="${style}">${text.charAt(0)}</span>`;
		$(selector).html(newFirstCharacter + text.slice(1, text.length))
	}

	function wrapValidationMessages(selector) {
		if ($(selector)) {
			const immediateTextElement = $(selector).contents().not($(selector).children());
			const text = immediateTextElement.text();
			immediateTextElement.detach();
			$(selector).append(`<span>${text}</span>`);
		}
	}

	function redirectToTheJumpPage() {
		const firstStepValues = [];

		$('.quote-process__form form .first-page .gfield').each(function () {
			firstStepValues.push($(this).find('.select-styled').text().trim())
		})

		const firstStepFormAnswers = {
			profession: firstStepValues[0],
			typeOfProfessional: firstStepValues[1],
			cosmeticsProcedures: firstStepValues[2],
		}

		if (firstStepFormAnswers.profession === 'Other' &&
			firstStepFormAnswers.typeOfProfessional === 'All other healthcare professionals') {
			window.location.href = `/jump-page/?type=${firstStepFormAnswers.typeOfProfessional}`
		}

		if (firstStepFormAnswers.profession === 'Other' &&
			firstStepFormAnswers.typeOfProfessional !== 'All other healthcare professionals' &&
			firstStepFormAnswers.cosmeticsProcedures === 'No') {
			window.location.href = `/jump-page/?type=${firstStepFormAnswers.typeOfProfessional}`
		}
	}

	$('.quote-process__form form .gform_page_footer>input').on('click', function () {
		redirectToTheJumpPage();
	});

	function toggleOverlayOnTooltipHover() {
		$('.quote-process__form form .question-tooltip').on('mouseenter', function () {
			if ($(this).siblings(".overlay").length < 1) {
				$(this).parent("li").append("<div class='overlay'></div>")
			}
			$(this).siblings(".overlay").show();
		})

		$('.quote-process__form form .question-tooltip').on('mouseleave', function () {
			if ($(window).width() > 768) {
				$(this).siblings(".overlay").hide();
			}
		})
	}

	function addAsteriskToLabel(selector) {
		$(`${selector} form .gfield_contains_required .material__form_label`).append('<span style="color: #FF0000">*</span>')
	}

	function createSelectWithSearch(field) {
		const $selectItem = $(field);
		const $selectList = $selectItem.find('.select-options');

		$selectList.wrap('<div class="enhanced-select-wrapper"></div>')

		$selectItem.find('.enhanced-select-wrapper').prepend('<div class="chosen-search material__form_group"><input type="text" autocomplete="off" class="material__form_field"></div>')


		$selectItem.find('.material__form_field').on('input', function () {
			const value = $(this).val().toLowerCase();
			let isElementsVisible = []

			$selectItem.find('.select-options li').each(function () {
				const lcval = $(this).text().toLowerCase();
				if (lcval.indexOf(value) > -1) {
					$(this).show();
				} else {
					$(this).hide();
				}

				isElementsVisible.push($(this).is(":visible"));
			});

			if (!isElementsVisible.includes(true)) {
				$selectList.find('.no-results').remove()
				$selectList.append(`<div class="no-results">No results matched "${value}"</div>`)
			} else {
				$selectList.find('.no-results').remove()
			}

		})
	}

	$(document).on('gform_post_render', function () {
		createCustomSelects('.quote-process__form');
		createCustomSelects('.user-info__form');
		toggleFormSteps();
		replaceLabels();
		createMaterialInputs('.quote-process__form');
		createMaterialInputs('.user-info__form');
		addAsteriskToLabel('.user-info__form');
		$('.gfrom_ajax_spinner').hide();
		toggleValidationAsterisk('.quote-process__form');
		addTooltipForFields();
		createFormProgressBar();
		changeStyleOnFirstCharacter('.quote-process__form form .second-page .gsection_description', 'color:#FF0000');
		changeStyleOnFirstCharacter('.user-info__form form .gsection_description', 'color:#FF0000');
		wrapValidationMessages('.quote-process__form form .gfield-email .validation_message');
		wrapValidationMessages('.quote-process__form form .gfield-phone .gfield_description.validation_message');

		createSelectWithSearch('.quote-process__form form .enhanced_user_interface')
		createSelectWithSearch('.user-info__form form .search-select')

		wrapValidationMessages('.user-info__form form .gfield-email .validation_message');
		wrapValidationMessages('.user-info__form form .gfield-phone .gfield_description.validation_message');
		$('.quote-process__form form .gfield-phone input').attr('inputmode', 'numeric');
		$('.quote-process__form form .gfield-email input').attr('type', 'email');
		$('.quote-process__form form .chosen-container').siblings('.select').hide();
		toggleOverlayOnTooltipHover();
	});

})(jQuery);
